<div class="compare-comp-wrapper">
  <app-header></app-header>
  <div class="body-wrapper">
    <img
      class="compare_bg"
      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/sosanh-bg.png"
      alt="sosanh-bg"
      height="auto"
      width="auto"
    />
    <img
      class="compare-bg-mobile"
      src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/sosanh-bg-mobile.png"
      alt="sosanh-bg"
      height="auto"
      width="auto"
    />
    <div class="banner">
      <div class="container">
        <h1>So sánh Wi-Fi 6 với Wi-Fi 5</h1>
        <p>
          FPT Telecom triển khai chương trình ưu đãi khi khách hàng hiện hữu
          thực hiện chuyển đổi thiết bị Wi-Fi 6 trên Hi FPT
        </p>
        <button><span>Đăng ký</span></button>
      </div>
    </div>
    <div class="carousel">
      <div class="container">
        <div class="carousel-wrapper">
          <ngx-slick-carousel class="list-product slide" [config]="slideConfig">
            <div class="item" *ngFor="let item of compareList" ngxSlickItem>
              <div class="col-wrapper">
                <div class="icon">
                  <img
                    src="{{ item.icon }}"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="col-content">
                  <h2 class="name">{{ item.title }}</h2>
                  <div class="text">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
  <app-spinner-layout></app-spinner-layout>
</div>
